import './App.css'
import { AppRouter } from './AppRouter'

function App(): JSX.Element {
  return <AppRouter />;
}

export default App;
